<template>
  <div class="root-box">
    <el-tabs v-model="tab">
      <el-tab-pane label="质检报告" name="ref1">
        <QcReport />
      </el-tab-pane>
      <el-tab-pane label="每日质检详情" name="ref2">
        <DriverDailyReport />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import DriverDailyReport from "./DriverDailyReport";
import QcReport from "./QcReport";

export default {
  components: {
    DriverDailyReport,
    QcReport
  },
  props: {},
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  data() {
    return {
      tab: "ref1"
    };
  },
  methods: {}
};
</script>
<style lang="less" scoped></style>
